import Knowledge from "./Knowledge";
export default Knowledge;
